/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const smsChallengeConfirmationBodyCodeRegExp = new RegExp('^\\d{6}$');

export const SmsChallengeConfirmationBody = zod.object({
  code: zod.string().regex(smsChallengeConfirmationBodyCodeRegExp),
});

export type SmsChallengeConfirmationBody = zod.input<typeof SmsChallengeConfirmationBody>;
export type SmsChallengeConfirmationBodyOutput = zod.output<typeof SmsChallengeConfirmationBody>;
